import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import Dashboard from './components/Dashboard/Dashboard';
import DomainRegistration from './components/Dashboard/DomainRegistration';
import Profile from './components/Profile/Profile';
import PrivateRoute from './components/PrivateRoute';
import PaymentVerification from './components/Admin/PaymentVerification';
import AuthCallback from './components/Auth/AuthCallback';
import DomainDetails from './components/Dashboard/DomainDetails';
import DomainList from './components/Dashboard/DomainList';
import DashboardLayout from './components/Dashboard/DashboardLayout';
import { useAuth } from './contexts/AuthContext';

const { Content } = Layout;

const AppRoutes = () => {
  const { isAdmin } = useAuth();
  return (
    <Layout>
      <Content style={{ padding: '0 10px' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/register-domain"
            element={
              <PrivateRoute>
                <DomainRegistration />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          {/* Admin routes */}
          <Route
            path="/admin/payments"
            element={
              <PrivateRoute adminOnly>
                <PaymentVerification />
              </PrivateRoute>
            }
          />
          
          <Route 
            path="/domains" 
            element={
              <PrivateRoute>
                  <DashboardLayout>
                    <DomainList />
                  </DashboardLayout>
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/domains/:domainId" 
            element={
              <PrivateRoute>
                <DomainDetails />
              </PrivateRoute>
            } 
          />
        </Routes>
      </Content>
    </Layout>
  )
};

export default React.memo(AppRoutes);